<div class="capability-card">
  <span class="capability-card-icon">
    @if (icon) {
    <lucide-icon [name]="icon"></lucide-icon>
    }
  </span>
  <div class="capability-card-content">
    <h3 class="capability-card-title">{{ title }}</h3>
    <ul class="capability-card-list">
      @for (item of items; track item) {
      <li>{{ item }}</li>
      }
    </ul>
  </div>
</div>
